/* FUZZY — global.js (ES module, no dependencies)
   Dialog drawers, header, nav, localization, cart (Section Rendering API), predictive search, sliders. */
const F = (window.Fuzzy = window.Fuzzy || {});
const S = F.strings || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const isRTL = () => document.documentElement.dir === 'rtl';
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
Object.assign(F, { $, $$, isRTL, reduced, debounce, parse });
/* Translated strings arrive HTML-escaped from Liquid (t filter): decode once for textContent use */
Object.keys(S).forEach((k) => { if (typeof S[k] === 'string' && S[k].includes('&')) { const ta = document.createElement('textarea'); ta.innerHTML = S[k]; S[k] = ta.value; } });

/* ---------- Money ---------- */
F.formatMoney = (cents, fmt = F.moneyFormat || '{{amount}}') => {
  const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
  if (!m) return String(cents);
  const cfg = {
    amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_apostrophe_separator: [2, "'", '.']
  }[m[1]] || [2, ',', '.'];
  const [i, d] = (Number(cents || 0) / 100).toFixed(cfg[0]).split('.');
  return fmt.replace(m[0], i.replace(/\B(?=(\d{3})+(?!\d))/g, cfg[1]) + (d ? cfg[2] + d : ''));
};

/* ---------- Dialogs (drawers & modals) ---------- */
const setExpanded = (id, v) => $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', String(v)));
F.openDialog = (dlg, trigger) => {
  if (!dlg || dlg.open) return;
  dlg._trigger = trigger || document.activeElement;
  dlg.showModal();
  document.body.classList.add('is-locked');
  setExpanded(dlg.id, true);
  dlg.dispatchEvent(new CustomEvent('dialog:open', { detail: { trigger } }));
};
document.addEventListener('close', (e) => {
  const dlg = e.target;
  if (!(dlg instanceof HTMLDialogElement)) return;
  setExpanded(dlg.id, false);
  if (!$('dialog[open]')) document.body.classList.remove('is-locked');
  if (dlg._trigger && dlg._trigger.isConnected) dlg._trigger.focus({ preventScroll: true });
}, true);

document.addEventListener('click', (e) => {
  const t = e.target;
  const opener = t.closest('[data-open]');
  if (opener) {
    const d = document.getElementById(opener.dataset.open);
    if (d) { e.preventDefault(); F.openDialog(d, opener); }
    return;
  }
  const closer = t.closest('[data-close]');
  if (closer) { closer.closest('dialog')?.close(); return; }
  if (t instanceof HTMLDialogElement && t.open) {
    const r = t.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
  }
  const cartToggle = t.closest('[data-cart-toggle]');
  const drawer = $('#CartDrawer');
  if (cartToggle && drawer && F.cartType === 'drawer') { e.preventDefault(); F.openDialog(drawer, cartToggle); }
});

/* ---------- Header: compact on scroll (sticky top offset hides padding; no layout shift) ---------- */
const headerSection = $('.section-header');
if (headerSection) {
  let ticking = false;
  const update = () => { headerSection.classList.toggle('is-compact', scrollY > 24); ticking = false; };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  update();
}

/* ---------- Desktop mega menu (<details>): one open at a time, hover intent, Esc, outside click ---------- */
const navDetails = $$('[data-nav-details]');
const canHover = matchMedia('(hover: hover) and (pointer: fine)').matches;
navDetails.forEach((d) => {
  const sum = d.querySelector('summary');
  d.addEventListener('toggle', () => { if (d.open) navDetails.forEach((o) => { if (o !== d) o.open = false; }); });
  if (canHover) {
    let timer;
    d.addEventListener('mouseenter', () => { clearTimeout(timer); if (!d.open) { d.open = true; d._hoverAt = Date.now(); } });
    d.addEventListener('mouseleave', () => { timer = setTimeout(() => { d.open = false; }, 160); });
    sum.addEventListener('click', (e) => { if (Date.now() - (d._hoverAt || 0) < 500) e.preventDefault(); });
  }
});
document.addEventListener('click', (e) => navDetails.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; }));
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  navDetails.forEach((d) => { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
});

/* ---------- Localization: auto-submit language switch ---------- */
document.addEventListener('change', (e) => {
  if (e.target.name === 'locale_code' && e.target.closest('[data-localization]')) e.target.form.submit();
});

/* ---------- Cart ---------- */
/* Offer ladder: grow the fill from its previous width after a re-render; pulse the step that was just unlocked */
const ladderFrom = (el, was, step) => {
  const fill = $('[data-ladder-fill]', el), lad = $('[data-ladder]', el);
  if (!fill || reduced()) return;
  was = was || '0%';
  const to = fill.style.getPropertyValue('--p');
  if (to === was) return;
  fill.style.setProperty('--p', was);
  fill.getBoundingClientRect();
  requestAnimationFrame(() => fill.style.setProperty('--p', to));
  if (+lad.dataset.ladder > step) lad.classList.add('is-bump');
};
const cart = (F.cart = {
  sectionIds() {
    const ids = new Set(['cart-icon-bubble']);
    if ($('#CartDrawer')) ids.add('cart-drawer');
    $$('[data-cart-section]').forEach((el) => ids.add(el.dataset.cartSection));
    return [...ids].slice(0, 5);
  },
  render(sections) {
    if (!sections) return;
    const a = document.activeElement;
    const line = a && a.closest('[data-line]');
    const focusKey = line ? `[data-line="${line.dataset.line}"] ${a.matches('[data-qty-step="1"]') ? '[data-qty-step="1"]' : a.matches('[data-qty-step="-1"]') ? '[data-qty-step="-1"]' : '[data-qty-input]'}` : null;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const src = parse(html).querySelector(`[data-cart-section="${id}"]`);
      if (src) $$(`[data-cart-section="${id}"]`).forEach((el) => {
        const was = $('[data-ladder-fill]', el)?.style.getPropertyValue('--p'), step = +($('[data-ladder]', el)?.dataset.ladder || 0);
        el.innerHTML = src.innerHTML;
        ladderFrom(el, was, step);
      });
    });
    if (focusKey) ($(focusKey) || $('#CartDrawer [data-close]') || $('#MainContent'))?.focus();
    document.dispatchEvent(new CustomEvent('cart:updated'));
  },
  showError(msg) {
    $$('[data-cart-error]').forEach((el) => { el.textContent = msg || S.cartError; el.hidden = false; });
  },
  async refresh() {
    const res = await fetch(`${location.pathname}?sections=${this.sectionIds().join(',')}`);
    if (res.ok) this.render(await res.json());
  },
  async change(line, quantity, item) {
    item?.classList.add('is-loading');
    try {
      const res = await fetch(`${F.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity, sections: this.sectionIds(), sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { await this.refresh(); this.showError(data.description || data.message); return; }
      this.render(data.sections);
    } catch (err) {
      item?.classList.remove('is-loading');
      this.showError();
    }
  }
});

const qtyTimers = {};
const queueQty = (item, qty) => {
  const line = item.dataset.line;
  clearTimeout(qtyTimers[line]);
  qtyTimers[line] = setTimeout(() => cart.change(line, qty, item), 350);
};
document.addEventListener('click', (e) => {
  const step = e.target.closest('[data-qty-step]');
  if (step) {
    const item = step.closest('[data-line]');
    const input = $('[data-qty-input]', item);
    const q = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep));
    input.value = q;
    queueQty(item, q);
    return;
  }
  const rm = e.target.closest('[data-remove]');
  if (rm) { e.preventDefault(); const item = rm.closest('[data-line]'); cart.change(item.dataset.line, 0, item); }
});
document.addEventListener('change', (e) => {
  const t = e.target;
  if (t.matches('[data-qty-input]')) queueQty(t.closest('[data-line]'), Math.max(0, parseInt(t.value, 10) || 0));
  if (t.matches('[data-cart-note]')) {
    fetch(`${F.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
  }
});

/* Gift note: cart attributes "Gift" / "Gift message" (debounced /cart/update.js). Pending text survives section re-renders. */
const gift = { on: null, msg: null, t: 0, p: null };
const giftSave = () => {
  clearTimeout(gift.t); gift.t = 0;
  const on = !!gift.on, attributes = { Gift: on ? 'Yes' : '', 'Gift message': on ? (gift.msg || '').slice(0, 200) : '' };
  gift.p = fetch(`${F.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) })
    .catch(() => {}).finally(() => { gift.p = null; });
  return gift.p;
};
const giftQueue = (ms) => { clearTimeout(gift.t); gift.t = setTimeout(giftSave, ms); };
const giftSync = (root) => {
  $$('[data-gift]', root).forEach((g) => {
    const c = $('[data-gift-check]', g), m = $('[data-gift-msg]', g), p = $('[data-gift-panel]', g), n = $('[data-gift-n]', g);
    if (gift.on !== null) c.checked = gift.on;
    if (gift.msg !== null && m.value !== gift.msg) m.value = gift.msg;
    p.hidden = !c.checked; m.disabled = !c.checked; g.classList.toggle('is-on', c.checked);
    if (n) n.textContent = m.value.length;
  });
};
document.addEventListener('change', (e) => {
  const c = e.target.closest('[data-gift-check]'); if (!c) return;
  gift.on = c.checked;
  const m = $('[data-gift-msg]', c.closest('[data-gift]'));
  if (gift.msg === null) gift.msg = m.value;
  giftSync(document);
  if (c.checked) requestAnimationFrame(() => m.focus());
  giftQueue(0);
});
document.addEventListener('input', (e) => {
  const m = e.target.closest('[data-gift-msg]'); if (!m) return;
  if (m.value.length > 200) m.value = m.value.slice(0, 200);
  gift.msg = m.value; gift.on = true;
  $$('[data-gift-msg]').forEach((x) => { if (x !== m) x.value = m.value; });
  $$('[data-gift-n]').forEach((x) => { x.textContent = m.value.length; });
  giftQueue(600);
});
document.addEventListener('cart:updated', () => giftSync(document));
/* Flush a pending save before checkout leaves the page */
document.addEventListener('submit', async (e) => {
  const f = e.target;
  if (f.matches('form[data-add-form]') || !(gift.t || gift.p)) return;
  if (!(e.submitter?.name === 'checkout' || $('[name="checkout"]', f))) return;
  e.preventDefault();
  if (gift.t) giftSave();
  await gift.p;
  const h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.append(h);
  f.submit();
}, true);
giftSync(document);

F.goCheckout = () => {
  const f = document.createElement('form');
  f.method = 'post'; f.action = F.routes.cart; f.hidden = true;
  f.innerHTML = '<input type="hidden" name="checkout" value="1">';
  document.body.append(f);
  f.submit();
};

/* Add to cart: any form[data-add-form] (PDP, sticky bar, upsell) */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-add-form]');
  if (!form) return;
  e.preventDefault();
  const btn = e.submitter || $('[name="add"]', form);
  if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
  const err = $('[data-form-error]', form);
  if (err) err.hidden = true;
  btn.setAttribute('aria-busy', 'true');
  const fd = new FormData(form);
  if (btn.name === 'id' && btn.value) fd.set('id', btn.value);
  /* Bundle & save (PDP block): pack=N → piece 1 = chosen variant, pieces 2..N = their colour chips; one request */
  const n = Math.min(3, Math.max(1, +fd.get('pack') || 1)), id = fd.get('id'), ids = [id];
  for (let i = 2; i <= n; i++) ids.push(fd.get(`pack_c${i}`) || id);
  ['pack', 'pack_c2', 'pack_c3'].forEach((k) => fd.delete(k));
  let body = fd, hd = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  if (n > 1) {
    const q = {}; ids.forEach((x) => { q[x] = (q[x] || 0) + 1; });
    body = JSON.stringify({ items: Object.entries(q).map(([vid, quantity]) => ({ id: +vid, quantity })), sections: cart.sectionIds(), sections_url: location.pathname });
    hd = { ...hd, 'Content-Type': 'application/json' };
  } else {
    fd.append('sections', cart.sectionIds().join(','));
    fd.append('sections_url', location.pathname);
  }
  try {
    const res = await fetch(`${F.routes.cartAdd}.js`, { method: 'POST', headers: hd, body });
    const data = await res.json();
    if (!res.ok || data.status) {
      if (err) { err.textContent = data.description || data.message || S.cartError; err.hidden = false; } else cart.showError(data.description);
      return;
    }
    /* Buy now: pieces are in the cart → straight to checkout (cart form POST keeps the storefront language) */
    if ('buyNow' in btn.dataset) {
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      F.goCheckout();
      return;
    }
    const drawer = $('#CartDrawer');
    const host = form.closest('dialog');
    if (F.cartType !== 'drawer' || !drawer) { location.href = F.routes.cart; return; }
    if (F.fly) { try { await F.fly(form); } catch (x) { /* decorative only */ } }
    if (host && host !== drawer) host.close();
    cart.render(data.sections);
    F.openDialog(drawer, btn);
    document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
  } catch (x) {
    if (err) { err.textContent = S.cartError; err.hidden = false; }
  } finally {
    btn.removeAttribute('aria-busy');
  }
});

/* ---------- Predictive search ---------- */
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = $('input[type="search"]', this);
    this.results = $('[data-results]', this);
    this.status = $('[data-status]', this);
    this.input.addEventListener('input', debounce(() => this.search(), 250));
    this.closest('dialog')?.addEventListener('dialog:open', () => requestAnimationFrame(() => this.input.focus()));
  }
  async search() {
    const q = this.input.value.trim();
    this.ctrl?.abort();
    if (q.length < 2) { this.results.innerHTML = ''; this.status.textContent = ''; return; }
    this.ctrl = new AbortController();
    const url = `${F.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
    try {
      const res = await fetch(url, { signal: this.ctrl.signal });
      if (!res.ok) return;
      const el = parse(await res.text()).querySelector('[data-predictive-results]');
      this.results.innerHTML = el ? el.innerHTML : '';
      const live = $('[data-live]', this.results);
      this.status.textContent = live ? live.textContent : '';
    } catch (x) { /* aborted */ }
  }
}
customElements.define('predictive-search', PredictiveSearch);

/* ---------- Scroll-snap slider arrows ---------- */
class ScrollSlider extends HTMLElement {
  connectedCallback() {
    this.track = $('[data-track]', this);
    this.btns = $$('[data-slide]', this);
    if (!this.track) return;
    this.btns.forEach((b) => b.addEventListener('click', () => {
      const dir = Number(b.dataset.slide) * (isRTL() ? -1 : 1);
      this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: reduced() ? 'auto' : 'smooth' });
    }));
    this.track.addEventListener('scroll', debounce(() => this.update(), 60), { passive: true });
    new ResizeObserver(() => this.update()).observe(this.track);
  }
  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const x = Math.abs(this.track.scrollLeft);
    const [prev, next] = this.btns;
    if (!prev) return;
    prev.parentElement.hidden = max < 4;
    prev.disabled = x < 4;
    next.disabled = x > max - 4;
  }
}
customElements.define('scroll-slider', ScrollSlider);

/* ---------- Quick add: touch "+" opens the shared size sheet with a clone of the card's form ---------- */
document.addEventListener('click', (e) => {
  const plus = e.target.closest('[data-quick-add]');
  if (!plus) return;
  const card = plus.closest('[data-card]');
  const sheet = $('#QuickSheet');
  const form = card && $('.qa__form', card);
  if (!sheet || !form) return;
  const clone = form.cloneNode(true);
  clone.removeAttribute('id');
  $$('[id]', clone).forEach((el) => { el.id += '-qs'; });
  $$('label[for]', clone).forEach((el) => { el.htmlFor += '-qs'; });
  $('[data-qs-title]', sheet).textContent = $('.card__title', card)?.textContent.trim() || S.quickAdd;
  const body = $('[data-qs-body]', sheet);
  body.replaceChildren();
  const price = $('[data-price]', card);
  if (price) { const p = price.cloneNode(true); p.classList.add('sheet__price'); body.append(p); }
  body.append(clone);
  F.openDialog(sheet, plus);
});

/* ---------- Quick view: fetch the quick-view section for the product and show it in #QuickView ---------- */
const qv = $('#QuickView');
if (qv) {
  const body = $('[data-qv-body]', qv);
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-view]');
    if (!b) return;
    e.preventDefault();
    body.innerHTML = `<p class="qv__loading" role="status">${S.loading || ''}</p>`;
    F.openDialog(qv, b);
    try {
      const u = new URL(b.dataset.url, location.href);
      u.searchParams.set('section_id', 'quick-view');
      const [html] = await Promise.all([fetch(u).then((r) => r.text()), import(F.assets.product)]);
      const root = parse(html).querySelector('[data-qv-root]');
      if (!root) throw new Error('qv');
      body.replaceChildren(document.importNode(root, true));
      qv.setAttribute('aria-labelledby', 'QvTitle');
    } catch (x) {
      body.innerHTML = `<p class="qv__loading" role="alert">${S.qvError || ''}</p>`;
    }
  });
  /* Keep "View full details" on the chosen colour; morph the visible image into the PDP gallery */
  document.addEventListener('variant:change', (e) => {
    const a = $('[data-qv-full]', body);
    if (a && e.detail.variant && body.contains($(`product-info[data-section="${e.detail.section}"]`))) {
      const u = new URL(a.href, location.href); u.searchParams.set('variant', e.detail.variant.id); a.href = u.toString();
    }
  });
  body.addEventListener('click', (e) => {
    if (!e.target.closest('[data-qv-full]')) return;
    const img = $$('.gallery__slide:not([hidden]) img', body).find((i) => { const r = i.getBoundingClientRect(); return r.width && r.left >= -2 && r.right <= innerWidth + 2; });
    if (img) img.style.viewTransitionName = 'pdp-media';
  });
  qv.addEventListener('close', () => { body.replaceChildren(); qv.setAttribute('aria-labelledby', 'QuickViewTitle'); });
}

/* ---------- View transition: morph the clicked card image into the PDP gallery ---------- */
document.addEventListener('click', (e) => {
  const a = e.target.closest('.card a[href]');
  if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
  const img = $('[data-card-media] .card__img', a.closest('[data-card]'));
  if (img) img.style.viewTransitionName = 'pdp-media';
});
addEventListener('pageshow', () => $$('.card__img').forEach((i) => { i.style.viewTransitionName = ''; }));

/* ---------- Background video respects reduced motion ---------- */
if (reduced()) $$('video[data-bg-video]').forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });

/* ===== v6 ===== */
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
const motion = () => document.body.classList.contains('motion-on') && !reduced();

/* Announcement: rotate real messages every 4s, pause on hover/focus */
class AnnounceRotator extends HTMLElement {
  connectedCallback() {
    this.items = $$('.announce__msg', this);
    if (this.items.length < 2) return;
    this.i = 0;
    const stop = () => clearInterval(this.t);
    const go = () => { stop(); this.t = setInterval(() => this.step(), 4000); };
    ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, stop));
    ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, go));
    go();
  }
  step() {
    this.items[this.i].classList.remove('is-active');
    this.i = (this.i + 1) % this.items.length;
    this.items[this.i].classList.add('is-active');
  }
}
customElements.define('announce-rotator', AnnounceRotator);

/* Mobile sticky "Shop now" bar: visible after the hero buttons leave the viewport, hidden while the featured product is on screen */
class HomeCta extends HTMLElement {
  connectedCallback() {
    const ctas = $('[data-hero-ctas]');
    const sel = this.dataset.near;
    const target = sel && sel.startsWith('#') ? document.getElementById(sel.slice(1)) : null;
    if (!ctas) return;
    this.past = false; this.near = false;
    new IntersectionObserver(([e]) => { this.past = !e.isIntersecting && e.boundingClientRect.top < 0; this.sync(); }).observe(ctas);
    if (target) new IntersectionObserver(([e]) => { this.near = e.isIntersecting; this.sync(); }, { rootMargin: '0px 0px -25% 0px' }).observe(target);
  }
  sync() {
    const show = this.past && !this.near;
    this.classList.toggle('is-visible', show);
    this.inert = !show;
    if (show) document.body.style.setProperty('--home-cta-h', `${this.offsetHeight}px`);
    document.body.classList.toggle('has-home-cta', show);
  }
}
customElements.define('home-cta', HomeCta);

/* Page-load progress bar (teal Z-slash) on internal navigation */
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href]');
  if (!a || e.defaultPrevented || a.target || e.metaKey || e.ctrlKey || e.shiftKey || a.hasAttribute('download')) return;
  const u = new URL(a.href, location.href);
  if (u.origin !== location.origin || (u.pathname === location.pathname && u.hash)) return;
  $('.zbar')?.classList.add('is-loading');
});
addEventListener('pageshow', () => $('.zbar')?.classList.remove('is-loading'));

/* Defer non-critical modules until idle: effects (decorative) + conversion helpers */
const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
idle(() => {
  if (F.fx && F.fx.on && !reduced()) import(F.assets.effects).catch(() => {});
  import(F.assets.convert).catch(() => {});
}, { timeout: 2500 });

/* Product card colour dots: hover (desktop) / tap swaps the card image and link to that colour */
const cardDot = (d) => {
  const card = d.closest('[data-card]'); if (!card) return;
  $$('.card__dot', card).forEach((x) => x.classList.toggle('is-on', x === d));
  const img = $('.card__img:not(.card__img--2)', card);
  if (img && d.dataset.src) { img.removeAttribute('srcset'); img.src = d.dataset.src; }
  if (d.dataset.url) $$('a.card__link, a.card__media', card).forEach((a) => { a.href = d.dataset.url; });
};
document.addEventListener('click', (e) => { const d = e.target.closest('.card__dot'); if (d) cardDot(d); });
document.addEventListener('mouseover', (e) => { const d = e.target.closest('.card__dot'); if (d && matchMedia('(hover: hover)').matches) cardDot(d); });
